import { useLocalSearchParams } from 'expo-router'

import { IntentionsScreen } from '@/src/features/intention/ui/screens/IntentionsScreen/IntentionsScreen'

export default function () {
  const searchParams = useLocalSearchParams()
  return <IntentionsScreen searchParams={searchParams} />
}
